import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import PlatformPage from "./pages/PlatformPage";
import AboutPage from "./pages/AboutPage";
import BlogsPage from "./pages/BlogsPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import ContactPage from "./pages/ContactPage";
import { useEffect } from "react";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

const toastOptions = {
    style: {
        background: "#0A0E23",
        border: "1px solid rgba(166,227,220,0.25)",
        color: "#fff",
    },
};

function Shell() {
    return (
        <div className="App relative xpo-grain min-h-screen">
            <Navbar />
            <ScrollToTop />
            <main className="relative">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/platform" element={<PlatformPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/blogs" element={<BlogsPage />} />
                    <Route path="/blogs/:slug" element={<BlogDetailPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                </Routes>
            </main>
            <Footer />
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={toastOptions}
            />
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Shell />
        </BrowserRouter>
    );
}

export default App;
